import Tippy from "@tippyjs/react";
import TextLimit from "Api/TextLimit";
import React, { useState, useEffect } from "react";
import { BsCheckCircle, BsXCircle, BsQuestionCircle } from "react-icons/bs";
import { IoIosInformationCircle } from "react-icons/io";
import { TbCircleLetterAFilled, TbCircleLetterGFilled } from "react-icons/tb";
import { ReactComponent as GreenExp } from "../../../../../assets/utils/images/svgs/GCircle.svg"
import { ReactComponent as OrangeExp } from "../../../../../assets/utils/images/svgs/OCircle.svg"
import { ReactComponent as PinkAExp } from "../../../../../assets/utils/images/svgs/aaicon.svg"
import { ReactComponent as PinkVExp } from "../../../../../assets/utils/images/svgs/vvicon.svg"
import { ReactComponent as PinkExp } from "../../../../../assets/utils/images/svgs/PCircle.svg"
import { RxDividerVertical } from "react-icons/rx";
import { PiAsteriskFill } from "react-icons/pi";
import moment from "moment";
import "../../../../../assets/pages/_planscreen.scss";

export default function AvailabilityCell({ row, table, cell }) {
  const { firstName, lastName, middleName, isLoadingAvailability } = row.original;
  const availabilityValue = cell.getValue();

  // Debug: Log what the cell is receiving
  const adminId = row.original.adminId;
  if (adminId === Number(adminId)) {
    const isFirstRow = table.getRowModel().rows[0]?.id === row.id;
    if (isFirstRow) {
      // console.log('[AVAIL-CELL-DEBUG] First cell render/update:', {
      //   adminId,
      //   availabilityValue,
      //   isArray: Array.isArray(availabilityValue),
      //   length: Array.isArray(availabilityValue) ? availabilityValue.length : 0,
      //   isLoadingAvailability,
      //   rowOriginal: row.original
      // });
    }
  }

  // Defensive: Handle null/undefined/empty array
  const initialValue = Array.isArray(availabilityValue) && availabilityValue.length > 0
    ? availabilityValue.map((i) => ({ ...i, show: i.active }))
    : [];
  const [data, setData] = useState(initialValue);

  const availabilityType = table.options.meta?.availabilityType;
  const hiddenColumns = table.options.meta?.hiddenColumns;

  useEffect(() => {
    if (!availabilityType) return;
    const baseValue = cell.getValue();

    // Defensive: Handle null/undefined/empty array
    if (!Array.isArray(baseValue) || baseValue.length === 0) {
      setData([]);
      return;
    }

    const updated = baseValue.map((i) => ({
      ...i,
      isLast:
        availabilityType === "rooster" &&
        moment(i.date, "DD-MM-YYYY").day() === 5,
      show: availabilityType === "rooster" ? true : i.active,
    }));

    setData(updated);
  }, [availabilityType, availabilityValue]);

  // const isHidden =
  //   hiddenColumns && hiddenColumns.find((item) => item.id === columnId);
  // if (isHidden) return <div className="ignore"></div>;
  const columnId = cell.column.id;
  const ignoredColumn = hiddenColumns?.find((item) => item.id === columnId);

  if (!ignoredColumn?.value) {
    return <div className="ignore"></div>;
  }

  // Show loading spinner while fetching availability
  if (isLoadingAvailability) {

    return (
      <div className="planscreen__availability-container" style={{
        height: '31px',
        overflowX: 'hidden',
        overflowY: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderBottom: '1px solid #dee2e6',
        backgroundColor: '#f8f9fa'
      }}>
        <div className="spinner-border spinner-border-sm text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }



  return (
    <div className="planscreen__availability-container" style={{
      height: '31px',
      overflowX: 'hidden',
      overflowY: 'hidden',
      display: 'flex',
      alignItems: 'center',
      borderBottom: '1px solid #dee2e6'
    }}>
      <div className="d-flex gap-1" style={{ minWidth: 'max-content' }}>
        {data.map((c, index) => {
          let value;
          const isActive = c.active;
          console.log("Availability item:", {
            value: c.value,
            active: c.active,
            show: c.show,
            dataId: c.dataId,
          });
          switch (c.value) {

            case "-":
              value = <BsXCircle color={isActive ? "#FB2E5F" : "#878EA6"} />;
              break;
            case "*":
              value = <PiAsteriskFill color={isActive ? "#FB2E5F" : "#878EA6"} />;
              break;
            case "i":
              value = (
                <IoIosInformationCircle size={25}
                  color={isActive ? "#3AC47D" : "#878EA6" } width={19} height={19}
                />
              );
              break;
            case "I":
              value = (
                <PinkExp
                  color={isActive ? "#FB2E5F" : "#878EA6"} width={19} height={19}
                />
              );
              break;
               case "V":
              value = (
                <PinkVExp
                  color={isActive ? "#FB2E5F" : "#878EA6"} width={19} height={19}
                />
              );
              break;
                case "A":
              value = (
                <PinkAExp
                  color={isActive ? "#FB2E5F" : "#878EA6"} width={19} height={19}
                />
              );
              break;
            case "+":
              value = <BsCheckCircle color={isActive ? "#3AC47D" : "#878EA6"} />;
              break;
            case "!":
              value = (
                <BsQuestionCircle color={isActive ? "#FF8B02" : "#878EA6"} />
              );
              break;
              case "G":
              value = (
                <TbCircleLetterGFilled
                  color={isActive ? "#FB2E5F" : "#878EA6"}/>
              );
              break;
            case "x":
              value = <IoIosInformationCircle size={25} color="#FF8B02"  width={15} height={15}/>;
              break;
            default:
              value = <RxDividerVertical color="#026094" />;
          }

          return (
            c.show && (
              <div
                key={index}
                className={`flex-shrink-0 planscreen__availability-cell ${c?.isLast && c.shift === "Middag" ? "me-2" : ""
                  }`}
              >
                <Tippy
                  content={
                    <>
                      {`${lastName} ${middleName ?? ""} ${firstName}`}
                      <br />
                      {`${c.weekday} ${c.shift.toLowerCase()} ${c.date}`}
                    </>
                  }
                  placement="bottom"
                  arrow
                  className="custom-tooltip"
                  appendTo={() => document.body}
                >
                  <span
                    data-id={c.dataId}
                    className="d-flex justify-content-center"
                  >
                    {value}
                  </span>
                </Tippy>
              </div>
            )
          );
        })}
      </div>
    </div>
  );
}
